export const CRUMB_KIND = {
  HOME: "home",
  SECTION: "section",
  PAGE: "page",
};

export const DROPDOWN_MENU_STYLE = {
  minWidth: 240,
  // AntD caps the menu at 100vh, but it opens ~130px down and never shifts up;
  // past the fold it must scroll inside itself, since a page scroll closes it.
  maxHeight: "calc(100vh - 160px)",
  overflowY: "auto",
};

export const SHEET_CLASS_NAMES = { content: "rounded-t-2xl" };
export const SHEET_STYLES = {
  body: { padding: 8, maxHeight: "70vh", overflowY: "auto" },
};
export const SHEET_MENU_STYLE = { borderInlineEnd: "none" };
